export const pageAnimation = {
  hidden: {
    opacity: 0,
    rotation: 0.06,
    transition: { delay: 1 },
  },
  show: {
    opacity: 1,
    rotation: 0.06,
    transition: { delay: 0.5 },
  },
  exit: {
    opacity: 0,
    rotation: 0.06,
    transition: {
      duration: 0.4,
    },
  },
}
